import styled from "@emotion/styled";
import { isNilOrEmpty } from "utils";

export { default as ValuesDebugger } from "./ValuesDebugger";
export { default as ErrorsDebugger } from "./ErrorsDebugger";
export { default as TextField } from "./Text";
export { TextFieldGroup } from "./Text";
export { default as SearchableSelectField } from "./SearchableSelect";
export { default as SelectField } from "./Select";
export { default as DOBSelectField } from "./DOBSelect";
export { default as SSNField } from "./SSNField";
export { default as StateSelectField } from "./StateSelect";
export { default as CurrencyInput } from "./CurrencyInput";
export { default as AddressWithPlacesAutocomplete } from "./AddressWithPlacesAutocomplete";

export const ErrorMessages = {
  Required: "This field is required",
  InvalidString: "This field cannot include special characters (e.g. $, %, *, &)",
  StringMin: (min) => `This field must be longer than ${min} characters`,
  StringMax: (max) => `This field cannot be longer than ${max} characters`,
  InvalidEmailAddress: "A valid email address is required",
  InvalidCardNumber: "Invalid Card Number",
  InvalidExpirationDate: "Invalid Expiration Date",
  InvalidSecurityCode: "Invalid Security Code",
  FirstAndLastNameRequired: "First and last name are required",
  InvalidStateForSelectedCountry: "A valid state is required for the selected country",
  InvalidSsn: "A valid social security number is required",
  AtLeastOneSupportingDocument: "At least one supporting document is required",
};

export const formatErrorMessages = (formatMessage) => ({
  Required: () =>
    formatMessage({
      defaultMessage: "This field is required",
      description: "Input validation error",
    }),
  InvalidString: () =>
    formatMessage({
      defaultMessage: "This field cannot include special characters (e.g. $, %, *, &)",
      description: "Input validation error",
    }),
  StringMin: ({ min }) =>
    formatMessage(
      {
        defaultMessage: "This field must be longer than {min} characters",
        description: "Input validation error",
      },
      { min }
    ),
  StringMax: ({ max }) =>
    formatMessage(
      {
        defaultMessage: "This field cannot be longer than {max} characters",
        description: "Input validation error",
      },
      {
        max,
      }
    ),
  InvalidEmailAddress: () =>
    formatMessage({
      defaultMessage: "A valid email address is required",
      description: "Input validation error",
    }),
  InvalidCardNumber: () =>
    formatMessage({
      defaultMessage: "Invalid Card Number",
      description: "Input validation error",
    }),
  InvalidExpirationDate: () =>
    formatMessage({
      defaultMessage: "Invalid Expiration Date",
      description: "Input validation error",
    }),
  InvalidSecurityCode: () =>
    formatMessage({
      defaultMessage: "Invalid Security Code",
      description: "Input validation error",
    }),
  FirstAndLastNameRequired: () =>
    formatMessage({
      defaultMessage: "First and last name are required",
      description: "Input validation error",
    }),
  InvalidStateForSelectedCountry: () =>
    formatMessage({
      defaultMessage: "A valid state is required for the selected country",
      description: "Input validation error",
    }),
  InvalidSsn: () =>
    formatMessage({
      defaultMessage: "A valid social security number is required",
      description: "Input validation error",
    }),
  AtLeastOneSupportingDocument: () =>
    formatMessage({
      defaultMessage: "At least one supporting document is required",
      description: "Input validation error",
    }),
});

export const ErrorMessageDiv = styled.div`
  color: red;
  font-size: 0.9em;
`;

export const validateName = (value) => {
  if (isNilOrEmpty(value)) return ErrorMessages.Required;
  return undefined;
};
